import { render, staticRenderFns } from "./UserLevels.vue?vue&type=template&id=29cd4f19&scoped=true"
import script from "./UserLevels.vue?vue&type=script&lang=js"
export * from "./UserLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cd4f19",
  null
  
)

export default component.exports